<template>
    <div :class="['ah-page', 'accounting-summary-page', { 'voucher-print': isVoucherPrinting }]">
        <div class="page-header">
            <div class="ah-container">
                <div class="page-title">帳務匯總表</div>
                <div class="header-tab">
                    <div class="tab-item" :class="{ active: QueryType === tp.key }" v-for="tp in typeList" :key="tp.key" @click="onTabItemClick(tp.key)">
                        <div class="tab-item-inner">{{ tp.label }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="query-bar">
            <div class="ah-container">
                <div class="query-items">
                    <span class="date-picker-set">
                        <el-select v-model="conditions.DateQueryType" size="small" @change="updateData">
                            <el-option v-if="QueryType === 1 || QueryType === 2" :key="3" :value="3" :label="QueryType === 1 ? '發票開立日期' : '請款單日期'" />
                            <el-option :key="2" :value="2" :label="accountsDateText" />
                            <el-option :key="1" :value="1" label="建立日期" />
                        </el-select>
                        <div class="date-picker-start-end">
                            <el-date-picker
                                v-model="conditions.StartDate"
                                type="date"
                                placeholder="開始日期"
                                value-format="timestamp"
                                size="small"
                                :clearable="false"
                                :picker-options="datePickerOptions"
                                @change="changeDatePerid"
                            />
                            <span>~</span>
                            <el-date-picker
                                v-model="conditions.EndDate"
                                type="date"
                                placeholder="結束日期"
                                value-format="timestamp"
                                size="small"
                                :clearable="false"
                                :picker-options="datePickerOptions"
                                @change="changeDatePerid($event, true)"
                            />
                        </div>
                    </span>
                    <el-select v-model="conditions.Status" class="status-select" @change="updateData" size="small">
                        <el-option :value="null" label="全部" />
                        <el-option :value="0" label="待檢核" />
                        <el-option :value="1" label="完成" />
                        <el-option :value="2" label="不作帳" />
                    </el-select>
                </div>
                <div class="actions">
                    <div class="search-items">
                        <el-input
                            v-model="conditions.Summary"
                            style="width: 200px"
                            size="small"
                            :placeholder="searchPlaceholder"
                            clearable
                            @clear="updateData"
                            @keypress.enter.native="updateData"
                        ></el-input>
                        <ahSelectVariableStateItem
                            v-if="isSelectVariableStateItemShow"
                            ref="ahSelectVariableStateItem"
                            v-model="conditions.itemSnos"
                            hide-tip
                            show-system-default
                            :enableType="selectVariableStateItemEnableType"
                            :showRefresh="false"
                            multiple
                            :width="280"
                            placeholder="搜尋收支項目"
                            size="small"
                            :collapseTags="true"
                        />
                        <el-button @click="updateData" type="primary" size="small" style="height: 34px">查詢</el-button>
                    </div>
                    <el-button v-if="QueryType !== 8 || (QueryType === 8 && !!loanReceiptSno)" size="small" :loading="isLoadingExport" @click="onExport">匯出Excel</el-button>
                </div>
                <!-- <div class="actions">
                    <el-button @click="exportAccoutingSummaryExcel" size="tiny">匯出帳務清單 </el-button>
                    <el-button @click="exportVouchersExcel" size="tiny">匯出傳票清單(XLS) </el-button>
                </div> -->
            </div>
        </div>
        <div class="data-table-area">
            <InvoiceTable v-if="QueryType === 1" :status="status" :datas="datas" @openDetail="onOpenDetail" @openReceipt="openInvoiceDetail" @selected="onSelected" />
            <PaymentTable v-else-if="QueryType === 2" :status="status" :datas="datas" @openDetail="onOpenDetail" @openReceipt="openPaymentDetail" @selected="onSelected" />
            <VariableStatementTable v-else-if="QueryType >= 3 && QueryType <= 6" :status="status" :datas="datas" @openDetail="onOpenDetail" @openReceipt="openVariableDetail" @selected="onSelected" />
            <SalaryTable v-else-if="QueryType === 7" :status="status" :datas="datas" @openDetail="onOpenDetail" @selected="onSelected" />
            <LoanTable
                v-else-if="QueryType === 8"
                ref="LoanTable"
                :status="status"
                :conditions="conditions"
                :datas="datas"
                @openDetail="onOpenDetail"
                @selected="onSelected"
                @contract-click="onLoanContractClick"
            />
            <BankTransferTable
                v-else-if="QueryType === 9"
                :status="status"
                :conditions="conditions"
                :datas="datas"
                @openDetail="onOpenDetail"
                @openReceipt="openBankTransferDetail"
                @selected="onSelected"
            />
            <PettyMoneyTable v-else-if="QueryType === 10" :status="status" :datas="datas" @openDetail="onOpenDetail" @openReceipt="openPettyCashDetail" @selected="onSelected" />
        </div>
        <div class="pagging">
            <div class="side-block">
                <template v-if="isAuth('G10') && selectedItems.length && !isQR()">
                    批次財會檢核（{{ selectedItems.length }}筆）
                    <el-radio-group v-model="batchVoucherStatus" size="mini" @change="onStatusChange">
                        <el-radio-button v-for="s in accountingStatusOptions" :key="s.key" :label="s.key">{{ s.label }}</el-radio-button>
                    </el-radio-group>
                    <el-button size="mini" style="margin-left: 10px" @click="onBulkReAutoVoucher">自動產生傳票</el-button>
                </template>
            </div>
            <div class="pagination">
                <el-pagination
                    v-if="QueryType !== 8"
                    layout="prev, pager, next"
                    :page-size.sync="conditions.PageSize"
                    :total.sync="totalDataCount"
                    :current-page.sync="conditions.PageNum"
                    @current-change="updateData"
                >
                </el-pagination>
            </div>
            <div class="side-block"></div>
        </div>
        <AccountingDetailDialog
            :visible="detailDialog.visible"
            :QueryType="detailDialog.QueryType"
            :sno="detailDialog.sno"
            @update="updateData"
            @beforePrint="beforeVoucherPrint"
            @afterPrint="afterVoucherPrint"
            @close="handleDetailDialogClose"
            @reOpen="onReOpenAccountingDetailDialog"
        >
        </AccountingDetailDialog>
        <PaymentDetailDialog @close="handlePaymentDetailDialogClose" :visible="paymentDetailDialog.visible" :sno="paymentDetailDialog.sno" />
        <InvoiceDetailDialog @close="handleInvoiceDetailDialogClose" :visible="invoiceDetailDialog.visible" :sno="invoiceDetailDialog.sno" />
        <VariableDetailDialog @close="handleVariableDetailDialogClose" :visible="variableDetailDialog.visible" :sno="variableDetailDialog.sno" />
        <PettyCashDetailDialog :visible="pettyCashDetailDialog.visible" :data="pettyCashDetailDialog.data" @close="handlePettyCashDetailDialogClose" />
        <BankTransferDetailDialog :visible="bankTransferDetailDialog.visible" :sno="bankTransferDetailDialog.sno" @close="onCloseBankTransferDetailDialog" />
        <BulkGenerateFailDialog :visible="bulkGenerateFailDialog.visible" :datas="bulkGenerateFailDialog.data" @close="onCloseBulkGenerateFailDialog" />
    </div>
</template>
<script>
import _ from 'lodash';
import moment from 'moment';
import { datePickerOption, accountingStatusOptions } from '@/assets/commonData/options';
import { exportFile } from '@/utils/fileProcess';
import PaymentDetailDialog from '@/components/dashboard/Payment/PaymentDetailDialog.vue';
import InvoiceDetailDialog from '@/components/dashboard/Invoice/InvoiceDetailDialog.vue';
import VariableDetailDialog from '@/components/dashboard/Finance/VariableStatement/DetailDialog.vue';
import PettyCashDetailDialog from '@/components/dashboard/Finance/PettyCash/DetailDialog.vue';
import AccountingDetailDialog from '@/components/dashboard/Accounting/AccountingSummary/AccountingDetailDialog.vue';
import InvoiceTable from '@/components/dashboard/Accounting/AccountingSummary/AccountingTableView/InvoiceTable.vue';
import PaymentTable from '@/components/dashboard/Accounting/AccountingSummary/AccountingTableView/PaymentTable.vue';
import VariableStatementTable from '@/components/dashboard/Accounting/AccountingSummary/AccountingTableView/VariableStatementTable.vue';
import SalaryTable from '@/components/dashboard/Accounting/AccountingSummary/AccountingTableView/SalaryTable.vue';
import LoanTable from '@/components/dashboard/Accounting/AccountingSummary/AccountingTableView/LoanTable.vue';
import BankTransferTable from '@/components/dashboard/Accounting/AccountingSummary/AccountingTableView/BankTransferTable.vue';
import BankTransferDetailDialog from '@/components/dashboard/Finance/VariableStatement/BankTransferDetailDialog.vue';
import PettyMoneyTable from '@/components/dashboard/Accounting/AccountingSummary/AccountingTableView/PettyMoneyTable.vue';
import ahSelectVariableStateItem from '@/components/ui/ahSelectVariableStateItem.vue';
import ExcelMixins from './ExcelMixins';

export default {
    name: 'AccountingSummaryPage',
    mixins: [ExcelMixins],
    components: {
        AccountingDetailDialog,
        PaymentDetailDialog,
        InvoiceDetailDialog,
        VariableDetailDialog,
        PettyCashDetailDialog,
        BankTransferDetailDialog,

        InvoiceTable,
        PaymentTable,
        VariableStatementTable,
        SalaryTable,
        LoanTable,
        BankTransferTable,
        PettyMoneyTable,
        BulkGenerateFailDialog: () => import('@/components/dashboard/Accounting/AccountingSummary/ui/BulkGenerateFailDialog.vue'),

        ahSelectVariableStateItem,
    },
    computed: {
        searchPlaceholder() {
            switch (this.QueryType) {
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
                return '搜尋摘要、系統單號';
            case 9:
                return '搜尋系統單號';
            case 10:
                return '搜尋系統單號';
            default:
                return '搜尋摘要';
            }
        },
        accountsDateText() {
            switch (this.QueryType) {
            case 1:
                return '(最新)入帳日期';
            case 2:
                return '付款日期';
            case 3:
            case 4:
            case 5:
            case 6:
            case 9:
            case 10:
                return '出/入帳日期';
            case 7:
            case 8:
                return '帳務日期';
            default:
                return '--';
            }
        },
        isSelectVariableStateItemShow() {
            switch (this.QueryType) {
            case 7:
            case 8:
            case 9:
            case 10:
                return false;
            default:
                return true;
            }
        },
        selectVariableStateItemEnableType() {
            switch (this.QueryType) {
            case 1:
                return ['invoice'];
            case 2:
                return ['payout'];
            case 3:
                return ['cIn'];
            case 4:
                return ['cInElse'];
            case 5:
                return ['cOut'];
            case 6:
                return ['cOutElse'];
            default:
                return [];
            }
        },
        pickerOptions() {
            return {
                shortcuts: datePickerOption.shortcuts.filter((x) => x.text !== '不限'),
            };
        },
        datePickerOptions() {
            const vm = this;
            return {
                shortcuts: [
                    {
                        text: '今天',
                        onClick(picker) {
                            picker.$emit('pick', null);
                            vm.conditions.StartDate = parseInt(moment().startOf('day').format('x'), 10);
                            vm.conditions.EndDate = parseInt(moment().endOf('day').format('x'), 10) - 999;
                        },
                    },
                    {
                        text: '昨天',
                        onClick(picker) {
                            picker.$emit('pick', null);
                            vm.conditions.StartDate = parseInt(moment().subtract(1, 'day').startOf('day').format('x'), 10);
                            vm.conditions.EndDate = parseInt(moment().subtract(1, 'day').endOf('day').format('x'), 10) - 999;
                        },
                    },
                    {
                        text: '本週',
                        onClick(picker) {
                            picker.$emit('pick', null);
                            vm.conditions.StartDate = parseInt(moment().startOf('week').format('x'), 10);
                            vm.conditions.EndDate = parseInt(moment().endOf('week').format('x'), 10) - 999;
                        },
                    },
                    {
                        text: '上週',
                        onClick(picker) {
                            picker.$emit('pick', null);
                            vm.conditions.StartDate = parseInt(moment().subtract(1, 'week').startOf('week').format('x'), 10);
                            vm.conditions.EndDate = parseInt(moment().subtract(1, 'week').endOf('week').format('x'), 10) - 999;
                        },
                    },
                    {
                        text: '本月',
                        onClick(picker) {
                            picker.$emit('pick', null);
                            vm.conditions.StartDate = parseInt(moment().startOf('month').format('x'), 10);
                            vm.conditions.EndDate = parseInt(moment().endOf('month').format('x'), 10) - 999;
                        },
                    },
                    {
                        text: '上個月',
                        onClick(picker) {
                            picker.$emit('pick', null);
                            vm.conditions.StartDate = parseInt(moment().subtract(1, 'month').startOf('month').format('x'), 10);
                            vm.conditions.EndDate = parseInt(moment().subtract(1, 'month').endOf('month').format('x'), 10) - 999;
                        },
                    },
                    {
                        text: '今年',
                        onClick(picker) {
                            picker.$emit('pick', null);
                            vm.conditions.StartDate = parseInt(moment().startOf('year').format('x'), 10);
                            vm.conditions.EndDate = parseInt(moment().endOf('year').format('x'), 10) - 999;
                        },
                    },
                    {
                        text: '去年',
                        onClick(picker) {
                            picker.$emit('pick', null);
                            vm.conditions.StartDate = parseInt(moment().subtract(1, 'year').startOf('year').format('x'), 10);
                            vm.conditions.EndDate = parseInt(moment().subtract(1, 'year').endOf('year').format('x'), 10) - 999;
                        },
                    },
                ],
            };
        },
    },
    data() {
        return {
            loanReceiptSno: null,
            isLoadingExport: false,
            batchVoucherStatus: -1,
            selectedItems: [],
            accountingStatusOptions,
            typeList: [
                { key: 1, label: '發票收入' },
                { key: 2, label: '請款支出' },
                { key: 3, label: '營業其他收入' },
                { key: 5, label: '營業其他支出' },
                { key: 4, label: '財務資產收入' },
                { key: 6, label: '財務資產支出' },
                { key: 7, label: '薪資支出' },
                { key: 8, label: '借款管理' },
                { key: 9, label: '存款帳戶互轉' },
                { key: 10, label: '零用現金' },
            ],
            isVoucherPrinting: false,
            showPopover: false,
            status: '',
            QueryType: 1,
            condit: {
                startDate: null,
                endDate: null,
            },
            conditions: {
                DateQueryType: 3,
                StartDate: null,
                EndDate: null,
                Status: null,
                Summary: null,
                itemSnos: null,
                PageNum: 1,
                PageSize: 25,
            },
            detailDialog: {
                visible: false,
                QueryType: null,
                sno: null,
            },
            numbersSummary: {
                invoiceIncomeCount: 0,
                requestedExpenseCount: 0,
                otherFinancialIncomeCount: 0,
                otherFinancialExpenseCount: 0,
                financialAssetIncomeCount: 0,
                financialAssetExpenseCount: 0,
                payrollCount: 0,
                loanManagementCount: 0,
            },
            datas: [],
            totalDataCount: 0,
            invoiceDetailDialog: {
                visible: false,
                sno: null,
            },
            paymentDetailDialog: {
                visible: false,
                sno: null,
            },
            variableDetailDialog: {
                visible: false,
                sno: null,
            },
            bankTransferDetailDialog: {
                visible: false,
                sno: null,
            },
            pettyCashDetailDialog: {
                visible: false,
                data: {},
            },
            bulkGenerateFailDialog: {
                visible: false,
                sno: null,
            },
        };
    },
    mounted() {
        const START_DATE = moment().startOf('month').format('x');
        const END_DATE = moment().endOf('month').format('x');
        this.conditions.StartDate = parseInt(START_DATE, 10);
        this.conditions.EndDate = parseInt(END_DATE, 10);

        this.updateData();
        this.$store.dispatch('accounting/updateAccountingSettings');
    },
    methods: {
        async onBulkReAutoVoucher() {
            try {
                await this.$confirm('確定要重新自動產生傳票？（原本已存在的傳票將會被覆蓋）', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                });

                this.status = 'loading';
                const data = _.map(this.selectedItems, (o) => ({
                    generateType: this.getGenerateType(o),
                    sno: this.getSno(o),
                    salaryQueryMonth: this.getSalaryQueryMonth(o),
                }));

                const resp = await this.$api({
                    url: '/AccountingSummaryPage/GenerateAutoVoucher',
                    method: 'POST',
                    data,
                });

                this.updateData();
                if (resp.data.errorResult.length) {
                    this.bulkGenerateFailDialog.visible = true;
                    this.bulkGenerateFailDialog.data = resp.data.errorResult;
                    return;
                }

                this.$message({ showClose: true, message: '傳票已重新產生', type: 'success' });
            } catch (e) {
                console.log(e);
            } finally {
                this.status = 'success';
            }
        },
        // 按下新增按鈕
        onOpenDetail(sno) {
            this.detailDialog.QueryType = this.QueryType;
            this.detailDialog.sno = sno;
            this.detailDialog.visible = true;
        },
        handleDetailDialogClose(refresh) {
            this.detailDialog.visible = false;
            this.detailDialog.sno = null;
            if (refresh) this.updateData();
        },
        openPaymentDetail(sno) {
            this.paymentDetailDialog.sno = sno;
            this.paymentDetailDialog.visible = true;
        },
        openInvoiceDetail(sno) {
            this.invoiceDetailDialog.sno = sno;
            this.invoiceDetailDialog.visible = true;
        },
        openVariableDetail(sno) {
            this.variableDetailDialog.sno = sno;
            this.variableDetailDialog.visible = true;
        },
        openPettyCashDetail(data) {
            this.pettyCashDetailDialog.data = data;
            this.pettyCashDetailDialog.visible = true;
        },
        openBankTransferDetail(sno) {
            this.bankTransferDetailDialog.sno = sno;
            this.bankTransferDetailDialog.visible = true;
        },
        handleInvoiceDetailDialogClose(refresh) {
            if (refresh) this.updateData();
            this.invoiceDetailDialog.visible = false;
            this.invoiceDetailDialog.sno = null;
        },
        handlePaymentDetailDialogClose(refresh) {
            if (refresh) this.updateData();
            this.paymentDetailDialog.visible = false;
            this.paymentDetailDialog.sno = null;
        },
        handleVariableDetailDialogClose(refresh) {
            if (refresh) this.updateData();
            this.variableDetailDialog.visible = false;
            this.variableDetailDialog.sno = null;
        },
        handlePettyCashDetailDialogClose(refresh) {
            this.$emit('detailClose', refresh);
            this.pettyCashDetailDialog.visible = false;
            this.pettyCashDetailDialog.data = {};
        },
        onCloseBankTransferDetailDialog(refresh) {
            if (refresh) this.updateData();
            this.bankTransferDetailDialog.visible = false;
            this.bankTransferDetailDialog.sno = null;
        },
        onCloseBulkGenerateFailDialog() {
            this.bulkGenerateFailDialog.visible = false;
        },
        async updateData() {
            this.loanReceiptSno = null;
            this.status = 'loading';
            this.errorMsg = '';

            let subUrl;
            let QueryType;
            this.conditions.PageSize = 25;
            switch (this.QueryType) {
            case 1:
                subUrl = 'GetInvoiceList';
                break;
            case 2:
                subUrl = 'GetPayoutList';
                break;
            case 3:
            case 4:
            case 5:
            case 6:
                subUrl = 'GetVariableStatementList';
                QueryType = this.QueryType;
                break;
            case 7:
                subUrl = 'GetSalaryList';
                break;
            case 8:
                subUrl = 'GetLoanManagementList';
                this.conditions.PageSize = 999;
                break;
            case 9:
                subUrl = 'GetAccountTransferRecordList';
                break;
            case 10:
                subUrl = 'GetPettyCashList';
                break;
            default:
            }

            const { query, resetQuery } = this.getManualQuery(this.conditions);
            const resp = await this.$api({
                url: `AccountingSummaryPage/${subUrl}${query}`,
                method: 'GET',
                params: { ...this.conditions, ...resetQuery, QueryType },
            });
            this.status = 'success';
            this.datas = resp.data.items;
            this.totalDataCount = resp.data.totalNum;
        },
        getManualQuery(query) {
            const returnValue = [..._.map(query.itemSnos, (o) => `itemSnos=${o}`)];
            return {
                query: returnValue.length ? `?${returnValue.join('&')}` : '',
                resetQuery: { itemSnos: undefined },
            };
        },
        changeDatePerid(val, isEndDate) {
            if (isEndDate) {
                // 結束日期選擇到天，預設時間為 23:59:59
                this.conditions.EndDate = parseInt(moment(val).endOf('day').format('x'), 10) - 999;
            } else {
                // 開始日期選擇到天，預設時間為 00:00:00
                this.conditions.StartDate = moment(val).startOf('day').format('x');
            }
            this.updateData();
        },
        onSearchTypeChange() {
            this.updateData();
        },
        onTabItemClick(queryType) {
            this.QueryType = queryType;
            if (queryType === 1 || queryType === 2) {
                // 發票＆請款單，日期類型預設選 開立日期＆請款單日期
                this.conditions.DateQueryType = 3;
            } else if (this.conditions.DateQueryType === 3) {
                // 其他帳務，選擇出/入帳日期 （其他帳務不一定有選項3）
                this.conditions.DateQueryType = 2;
            }
            this.conditions.itemSnos = [];
            this.$nextTick(() => {
                if (this.$refs.ahSelectVariableStateItem) {
                    this.$refs.ahSelectVariableStateItem.clear();
                }
            });
            this.updateData();
        },
        handleTabClick() {
            this.updateData();
        },
        async exportAccoutingSummaryExcel() {
            return;
            // eslint-disable-next-line no-unreachable
            const resp = await this.$api({
                url: 'AccountingSummaryPage/GetQueryAccoutingSummaryExcel',
                method: 'GET',
                params: this.conditions,
                responseType: 'blob',
            });
            exportFile(resp, this.getExportFileName('帳務清單'));
        },
        async exportVouchersExcel() {
            const resp = await this.$api({
                url: 'AccountingSummaryPage/GetQueryVouchersExcel',
                method: 'GET',
                params: this.conditions,
                responseType: 'blob',
            });
            exportFile(resp, this.getExportFileName('傳票清單'));
        },
        getExportFileName(mainTitle) {
            const typeText = this.conditions.DateQueryType === 'create' ? '成單' : '出入帳';
            const sd = moment(this.conditions.StartDate).format('YYYY-MM-DD');
            const ed = moment(this.conditions.EndDate).format('YYYY-MM-DD');
            return `${mainTitle}-${typeText}(${sd}_${ed}).xlsx`;
        },
        beforeVoucherPrint() {
            this.isVoucherPrinting = true;
            document.getElementById('app').style.display = 'none';
        },
        afterVoucherPrint() {
            this.isVoucherPrinting = false;
            document.getElementById('app').style.display = 'block';
        },

        onSelected(val) {
            this.selectedItems = val;
        },
        async onStatusChange() {
            const data = _.map(this.selectedItems, (o) => ({
                sno: this.getSno(o),
                voucherType: this.QueryTypeToVoucherType(this.QueryType, o),
                unt: this.getUntName(this.QueryType, o),
                UNT_NBR: this.getUNT_NBR(this.QueryType, o),
                status: this.batchVoucherStatus,
            }));

            try {
                this.status = 'loading';
                const resp = await this.$api({
                    url: '/AccountingSummaryPage/UpdateAccountStatus',
                    method: 'post',
                    data,
                });

                this.$message({
                    showClose: true,
                    message: `批次財會檢核，已完成 ${resp.data.success.length} 張`,
                    type: 'success',
                });
                await this.updateData();
                if (this.QueryType === 8) this.$refs.LoanTable.updateData();
            } finally {
                this.status = 'success';
                this.selectedItems = [];
                this.batchVoucherStatus = -1;
            }
        },
        getSno(o) {
            if (this.QueryType === 7) return undefined;
            if (this.QueryType === 8 && o.repaymentSno) return o.repaymentSno;
            if (this.QueryType === 8 && !o.repaymentSno) return o.drawdownSno;
            return o.sno;
        },
        getGenerateType(o) {
            switch (this.QueryType) {
            case 1:
                return 1;
            case 2:
                return 2;
            case 3:
                return 3;
            case 4:
                return 4;
            case 5:
                return o.froM_UNT === 'REM_FEE' ? 12 : 5;
            case 6:
                return 6;
            case 7:
                return 7;
            case 8:
                if (o.repaymentSno) return 9;
                return 8;
            case 9:
                return 10;
            case 10:
                return 11;
            default:
                return 0;
            }
        },
        getSalaryQueryMonth(o) {
            switch (this.QueryType) {
            case 7:
                return { year: o.year, month: o.month };
            default:
                return null;
            }
        },
        getUNT_NBR(queryType, item) {
            switch (queryType) {
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
                return item.uniqueNumber;
            case 8:
            case 9:
            case 10:
                return item.systemNo;
            case 7:
                return moment(`${item.year}/${item.month}/01`).format('YYYYMM');
            default:
                return '';
            }
        },
        QueryTypeToVoucherType(queryType, item) {
            switch (queryType) {
            case 1:
                return 1; // 發票收入
            case 2:
                return 2; // 請款支出
            case 3:
            case 4:
            case 5:
            case 6:
                return 3; // 財務收支
            case 7:
                return 4; // 薪資支出
            case 8:
                return item.repaymentSno ? 7 : 6; // 借款管理
            case 9:
                return 8; // 存款帳戶互轉
            case 10:
                return 9; // 零用現金
            default:
                return 0;
            }
        },
        getUntName(queryType, item) {
            switch (queryType) {
            case 1:
                return 'INVOICE'; // 發票收入
            case 2:
                return 'PAYMENT'; // 請款支出
            case 3:
            case 4:
            case 5:
            case 6:
                return 'MONEY_INOUT'; // 財務收支
            case 7:
                return 'SALARY'; // 薪資支出
            case 8:
                return item.repaymentSno ? 'LoanReceiptRepayment' : 'LoanReceiptDrawdown'; // 借款管理
            case 9:
                return 'TRANSFER';
            case 10:
                return 'PettyCash';
            default:
                return '';
            }
        },

        onLoanContractClick(sno) {
            this.loanReceiptSno = sno;
        },

        onReOpenAccountingDetailDialog(queryType, sno) {
            this.detailDialog.visible = false;
            this.detailDialog.QueryType = queryType;
            this.detailDialog.sno = sno;
            this.$nextTick(() => {
                this.detailDialog.visible = true;
            });
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.accounting-summary-page {
    padding-bottom: 0;

    .page-header {
        .ah-container {
            display: flex;
            width: 100%;
            overflow-x: auto;
        }
        .page-title {
            font-size: 12pt;
            font-weight: bold;
            margin-right: 80px;
            white-space: nowrap;
        }
    }

    &.voucher-print {
        .page-header {
            display: none;
        }
        .accounting-summary-page-content {
            display: none;
        }
    }

    .table-view-section {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .header-tab {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: 5px;

        > .tab-item {
            position: relative;
            color: rgba(255, 255, 255, 0.75);
            cursor: pointer;

            $corner-radius: 10px;
            $corner-radius2x: 20px;

            &.active {
                color: #463cb2 !important;
                font-weight: bold;

                > .tab-item-inner {
                    background-color: #fff;
                }

                & > .tab-item-inner::before {
                    content: "";
                    position: absolute;
                    bottom: 0;
                    right: -$corner-radius;
                    width: $corner-radius;
                    height: $corner-radius;
                    background-color: white;
                    z-index: 0;
                }
                & > .tab-item-inner::after {
                    content: "";
                    position: absolute;
                    bottom: 0;
                    right: -$corner-radius2x;
                    width: $corner-radius2x;
                    height: $corner-radius2x;
                    border-radius: $corner-radius;
                    background-color: #463cb2;
                }

                &::before {
                    content: "";
                    position: absolute;
                    bottom: 0;
                    left: -$corner-radius;
                    width: $corner-radius;
                    height: $corner-radius;
                    background-color: white;
                }
                &::after {
                    content: "";
                    position: absolute;
                    bottom: 0;
                    left: -$corner-radius2x;
                    width: $corner-radius2x;
                    height: $corner-radius2x;
                    border-radius: $corner-radius;
                    background-color: #463cb2;
                }
            }

            &:hover {
                color: #fff;
            }

            > .tab-item-inner {
                font-size: 10pt;
                padding: 5px 18px 10px 18px;
                border-top-right-radius: 8px;
                border-top-left-radius: 8px;
                white-space: nowrap;
            }
        }
    }

    .query-bar {
        background-color: #fff;
        padding: 0;

        > div {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .ah-container {
            .actions {
                display: flex;
                margin: 10px 0;
                gap: 5px;
            }
        }
        .query-items {
            display: flex;
            margin: 5px 0;
            > *:not(:last-child) {
                margin-right: 10px;
            }
        }
        .search-items {
            display: flex;
            justify-content: space-between;
            gap: 5px;

            .el-input--small .el-input__inner {
                height: 34px;
            }
            .el-cascader__tags .el-tag {
                max-width: 50%;
            }
        }
        .date-picker-set {
            display: flex;
            border-radius: 5px;
            padding: 1px;
            background-color: #fff;
            border: 1px solid #d6dae1;

            input,
            .el-date-editor {
                border: 0 !important;
                background-color: transparent;
                font-weight: bold;
                text-align: center;
            }
            .el-date-editor input {
                font-weight: normal;
            }

            > :first-child {
                width: 150px;
                border-right: 1px solid #d6dae1;
            }
            > :last-child {
                font-size: 11pt;

                i.el-input__icon {
                    display: none;
                    width: 0;
                }
            }

            .date-picker-start-end {
                display: flex;
                align-items: center;
                gap: 5px;
                padding: 0 5px;

                .el-date-editor {
                    width: 110px;

                    .el-input__inner {
                        font-size: 10pt;
                        height: 30px;
                        padding-left: 5px;
                        padding-right: 5px;
                        text-align: center;
                    }
                }
            }
        }
        .status-select {
            width: 120px;
            background-color: #fff;
            border-radius: 5px;
            border: 1px solid #d6dae1;

            input {
                background-color: transparent;
                border: 0;
                height: 34px;
                font-weight: bold;
            }
        }
    }

    .pagging {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 40px;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        align-items: center;
        background-color: #fff;
        .pagination {
            justify-self: center;
        }
        .side-block {
            padding: 0 20px;
            font-size: 10pt;
            &:last-child {
                justify-self: end;
            }
        }
    }
}
</style>
